import React, { useState } from "react";
import { getBrandName } from "../common/brand";

export default function TopInstallBanner({
  onInstallWebApp,
  onDownloadApp,
  onClose,
}) {
  const [visible, setVisible] = useState(true);

  const handleClose = () => {
    setVisible(false);
    onClose?.();
  };

  if (!visible) return null;
  const brandName = getBrandName();

  return (
    <>
      <div className="top-install-banner">
        <a
          type="button"
          className="install-card install-card-dark"
          href={window.location.hostname + "/" + "/app/origin.apk"}
        >
          <span className="install-app-icon web-app-icon">
            <span className="web-logo-text">{brandName}</span>
            {/* <span className="web-lightning">⚡</span> */}
          </span>

          <span className="install-card-text">Install Web APP</span>

          <span className="install-arrow" aria-hidden="true">
            ▶
          </span>
        </a>

        <a
          type="button"
          className="install-card install-card-blue"
          href="https://play.google.com/store/apps/details?id=com.cloudflare.onedotonedotonedotone"
        >
          <span className="install-app-icon download-app-icon">
            <span className="download-badge">14</span>
          </span>

          <span className="install-card-text">Download APP</span>

          <span className="install-arrow" aria-hidden="true">
            ▶
          </span>
        </a>

        <button
          type="button"
          className="install-close-btn"
          onClick={handleClose}
          aria-label="Close banner"
        >
          ✖
        </button>
      </div>

      <style>{`
     

        .top-install-banner {
          position: sticky;
          top: 0;
          z-index: 9999;
          width: 100%;
          display: flex;
          align-items: center;
          gap: 12px;
          padding: 10px 14px;
          background: linear-gradient(180deg, var(--top-install-banner-bg-start) 0%, var(--top-install-banner-bg-end) 100%);
          border-bottom: 1px solid var(--top-install-banner-border);
          box-sizing: border-box;
        }

        .install-card {
          flex: 1;
          min-width: 0;
          height: 48px;
          border: none;
          border-radius: 10px;
          display: flex;
          align-items: center;
          gap: 10px;
          padding: 0 12px;
          cursor: pointer;
          color: var(--install-card-text-color);
          box-sizing: border-box;
          transition: transform 0.18s ease, filter 0.18s ease;
        }

        .install-card:active {
          transform: scale(0.98);
        }

        .install-card-dark {
          background: linear-gradient(180deg, var(--install-card-dark-start) 0%, var(--install-card-dark-end) 100%);
          box-shadow: inset 0 1px 0 var(--install-card-dark-shadow);
        }

        .install-card-blue {
          background: linear-gradient(90deg, var(--install-card-blue-start) 0%, var(--install-card-blue-end) 100%);
          box-shadow: inset 0 1px 0 var(--install-card-blue-shadow);
        }

        .install-app-icon {
          width: 38px;
          height: 38px;
          min-width: 38px;
          border-radius: 8px;
          position: relative;
          overflow: hidden;
          display: flex;
          align-items: center;
          justify-content: center;
          flex-shrink: 0;
        }

        .web-app-icon {
          background: var(--web-app-icon-bg);
          border: 1px solid var(--web-app-icon-border);
        }

        .web-logo-text {
          position: absolute;
          top: 4px;
          left: 4px;
          right: 4px;
          font-size: 6px;
          line-height: 1;
          font-weight: 700;
          text-align: center;
          color: var(--web-logo-text-color);
          letter-spacing: 0.2px;
          white-space: nowrap;
        }

        .web-lightning {
          position: absolute;
          bottom: 2px;
          left: 50%;
          transform: translateX(-50%);
          font-size: 19px;
          line-height: 1;
          color: var(--web-lightning-color);
        }

        .download-app-icon {
          background:
            linear-gradient(135deg, var(--download-app-icon-start) 0%, var(--download-app-icon-mid) 45%, var(--download-app-icon-end) 100%);
        }

        .download-app-icon::before {
          content: "";
          position: absolute;
          top: -8px;
          left: 6px;
          width: 18px;
          height: 18px;
          background: var(--download-app-icon-before-bg);
          border-radius: 4px 4px 10px 4px;
          transform: rotate(45deg);
          opacity: 0.95;
        }

        .download-badge {
          position: relative;
          z-index: 1;
          font-size: 15px;
          font-weight: 800;
          color: var(--download-badge-color);
          text-shadow: 0 1px 1px var(--download-badge-shadow);
        }

        .install-card-text {
          flex: 1;
          min-width: 0;
          font-size: 15px;
          font-weight: 500;
          white-space: nowrap;
          overflow: hidden;
          text-overflow: ellipsis;
          text-align: left;
        }

        .install-arrow {
          font-size: 16px;
          line-height: 1;
          opacity: 0.9;
          flex-shrink: 0;
        }

        .install-close-btn {
          width: 28px;
          height: 28px;
          min-width: 28px;
          border: none;
          border-radius: 50%;
          background: linear-gradient(180deg, var(--install-close-btn-start) 0%, var(--install-close-btn-end) 100%);
          color: var(--install-close-btn-color);
          font-size: 15px;
          font-weight: 700;
          display: flex;
          align-items: center;
          justify-content: center;
          cursor: pointer;
          flex-shrink: 0;
          transition: transform 0.18s ease, filter 0.18s ease;
        }

        .install-close-btn:active {
          transform: scale(0.96);
        }

        .install-card:hover,
        .install-close-btn:hover {
          filter: brightness(1.04);
        }

        @media (max-width: 640px) {
          .top-install-banner {
            gap: 8px;
            padding: 8px 10px;
          }

          .install-card {
            height: 30px;
            padding: 0 10px;
            gap: 8px;
            border-radius: 6px;
          }

          .install-app-icon {
            width: 20px;
            height: 20px;
            min-width: 20px;
            border-radius: 7px;
          }

          .install-card-text {
            font-size: 12px;
          }

          .install-arrow {
            font-size: 13px;
          }

          .install-close-btn {
            width: 28px;
            height: 28px;
            min-width: 28px;
            font-size: 13px;
          }

          .web-logo-text {
            font-size: 5px;
          }

          .web-lightning {
            font-size: 16px;
          }

          .download-badge {
            font-size: 13px;
          }
        }
      `}</style>
    </>
  );
}